import { ErrorApi } from "../api.ts";
import type { PacienteSimilar } from "../../../dominio/src/index.ts";
import { AvisoError } from "../pantallas/comun.tsx";

/** ¿El servidor respondió «hay un paciente muy parecido»? */
export const esErrorDuplicado = (e: unknown): e is ErrorApi => e instanceof ErrorApi && e.datos?.codigo === "posible_duplicado";

const fecha = (iso: string | null) => (iso ? iso.split("-").reverse().join("/") : "sin fecha de nacimiento");

/**
 * Lo que se muestra cuando al registrar o editar un paciente se encuentra uno muy parecido: sus datos, para abrir esa ficha (o usarla, en la agenda),
 * y una casilla para confirmar que NO es la misma persona. Con la casilla marcada, quien llama reenvía el guardado con `confirmarDuplicado`.
 * Si el error es otro, se muestra el aviso de error de siempre.
 */
export function AvisoConDuplicado({ error, confirmado, alCambiar, alUsar }: {
  error: unknown; confirmado: boolean; alCambiar: (v: boolean) => void; alUsar?: (p: PacienteSimilar) => void;
}) {
  if (!esErrorDuplicado(error)) return <AvisoError error={error} />;
  const similares = (error.datos?.similares ?? []) as PacienteSimilar[];
  return (
    <div className="aviso" role="alert" style={{ display: "grid", gap: 8 }}>
      <b>¿Es la misma persona? Ya hay {similares.length === 1 ? "un paciente parecido" : "pacientes parecidos"}:</b>
      <ul className="lista" style={{ margin: 0 }}>
        {similares.map((s) => (
          <li key={s.id} style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", justifyContent: "space-between", padding: "4px 0" }}>
            <span>
              <b>{s.nombres} {s.apellidos}</b> · HC {s.hc} · {fecha(s.nacimiento)}{s.telefono ? ` · ${s.telefono}` : ""}
              {s.registro_rapido && <span className="chip" style={{ marginLeft: 6 }}>Registro rápido: falta completar su ficha</span>}
            </span>
            <span className="fila" style={{ gap: 6 }}>
              {alUsar && <button type="button" className="btn chico pri" onClick={() => alUsar(s)}>Usar este paciente</button>}
              <a className="btn chico" href={`#/paciente/${s.id}/ficha`} target="_blank" rel="noopener">Abrir su ficha</a>
            </span>
          </li>
        ))}
      </ul>
      <label className="fila" style={{ gap: 6, alignItems: "flex-start" }}>
        <input type="checkbox" checked={confirmado} onChange={(e) => alCambiar(e.target.checked)} />
        <span>No es la misma persona (gemelos, un homónimo o un familiar con el mismo celular). Registrar de todos modos y volver a pulsar el botón. Queda anotado quién lo confirmó.</span>
      </label>
    </div>
  );
}
